import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useBooking} from "../hooks/useBooking";

const BookingSuccessfulPage = () => {
    const navigate = useNavigate();
    const {bookingUuid} = useParams();
    const {booking} = useBooking(bookingUuid);

    if (!booking || Object.keys(booking).length === 0) {
        return <div>Loading...</div>;
    }

    const {eventName, eventStartedAt, eventEndedAt} = booking;

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-6">
                Buchung erfolgreich
            </h1>

            {/* Green Circle with Checkmark */}
            <div className="flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
                <span className="text-green-500 text-3xl font-bold">&#10003;</span>
            </div>

            <div className="bg-white shadow-md rounded-lg p-4 w-full max-w-md">
                <div className="flex items-center mb-2">
                    <h2 className="font-bold text-gray-800">{eventName}</h2>
                </div>
                <p className="text-sm text-gray-600">
                    {new Date(eventStartedAt).toLocaleDateString("de-DE", {
                        weekday : "long",
                        day     : "2-digit",
                        month   : "2-digit",
                        year    : "numeric",
                    })}{" "}
                    |{" "}
                    {new Date(eventStartedAt).toLocaleTimeString("de-DE", {
                        hour   : "2-digit",
                        minute : "2-digit",
                    })}{" "}
                    -{" "}
                    {new Date(eventEndedAt).toLocaleTimeString("de-DE", {
                        hour   : "2-digit",
                        minute : "2-digit",
                    })}
                </p>
            </div>
            <div className="flex space-x-4 mt-6">
                <button
                    onClick={() => navigate("/account")}
                    className="bg-pegasusPurple text-white py-2 px-4 rounded-lg font-semibold hover:bg-pegasusPurpleHover"
                >
                    ZU DEINEN BUCHUNGEN
                </button>
                <button
                    onClick={() => navigate("/")}
                    className="border border-pegasusPurple text-pegasusPurple py-2 px-4 rounded-lg font-semibold hover:bg-pink-100"
                >
                    ZURÜCK ZUM KALENDER
                </button>
            </div>
        </div>
    );
};

export default BookingSuccessfulPage;
